<div class="modal-header">
  <app-summary-top
    class="w-100"
    [header]="header"
    [model$]="observableSummaryTopModel"
    [additionalButtons]="additionalButtons"
    [summaryItems]="summaryItems"
    [showSave]="showSave"
    [showBack]="showBack"
    [saveButtonText]="saveButtonText"
  ></app-summary-top>
</div>

<div class="modal-body p-3">
  @if (fields) {
    <app-base-inline-form
      [submitText]="submitText"
      [submitIcon]="submitIcon"
      [model]="formModel"
      [fields]="fields"
      [header]="inlineHeader"
      [labelsVertical]="labelsVertical"
      [fullWidth]="fullWidth"
      (submitted)="submitted.emit($event)"
    ></app-base-inline-form>
  }
  <app-grid
    [gridCssClass]="gridCssClass"
    [columnDefs]="columnDefs"
    [stateKey]="gridStateKey"
    [multiSelectRows]="multiSelectRows"
    [rowData]="rowData ?? (rowData$ | async)"
    [showDelete]="showDelete"
    [showDiscard]="showSave"
    [header]="gridHeader"
    (delete)="delete.emit($event)"
    (comment)="comment.emit($event)"
    (edit)="edit.emit($event)"
    (rowSelected)="rowSelected.emit($event)"
    (save)="save.emit()"
  ></app-grid>
</div>
